import CodeEditor from "@uiw/react-textarea-code-editor";

export const LANGUAGES = [
  "javascript", "typescript", "python", "jsx", "tsx", "java", "go", "rust",
  "c", "cpp", "csharp", "ruby", "php", "sql", "bash", "json", "yaml", "html", "css", "markdown",
];

export const CODE_LINE_HEIGHT = 21;
export const CODE_PADDING = 14;

export function CodeEditorField({ value, onChange, language = "javascript", readOnly = false, minHeight = 140, onCaretLine }) {
  const reportCaret = (e) => {
    if (!onCaretLine) return;
    const ta = e.target;
    const line = (ta.value.slice(0, ta.selectionStart).match(/\n/g) || []).length + 1;
    onCaretLine(line);
  };
  return (
    <div className="border border-border rounded-lg overflow-hidden" data-color-mode="light">
      <CodeEditor
        value={value}
        language={language}
        readOnly={readOnly}
        onChange={(e) => onChange && onChange(e.target.value)}
        onKeyUp={reportCaret}
        onClick={reportCaret}
        padding={CODE_PADDING}
        placeholder={readOnly ? "" : "Paste or write code here…"}
        data-testid="code-editor-field"
        style={{
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: 13,
          lineHeight: `${CODE_LINE_HEIGHT}px`,
          minHeight,
          backgroundColor: "hsl(222 47% 11%)",
          color: "#e6edf3",
        }}
      />
    </div>
  );
}
